export default __webpack_public_path__ + "static/media/do2meClient.805c89fd.gif";